import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { SalesAssistantStore } from '../../../auth/models/principal';
import type { RootState } from '../../../../core/store';

const selectedStoreKey = 'sales-assistant-selected-store';

const getInitialSelectedStore = (): SalesAssistantStore | null => {
  const selectedStore = sessionStorage.getItem(selectedStoreKey);
  if (selectedStore == null) {
    return null;
  }

  try {
    return JSON.parse(selectedStore) as SalesAssistantStore;
  } catch {
    sessionStorage.removeItem(selectedStoreKey);
    return null;
  }
};

const persistSelectedStore = (selectedStore: SalesAssistantStore): SalesAssistantStore => {
  sessionStorage.setItem(selectedStoreKey, JSON.stringify(selectedStore));
  return selectedStore;
};

const clearSelectedStore = (): null => {
  sessionStorage.removeItem(selectedStoreKey);
  return null;
};

interface SalesAssistantSlice {
  selectedStore: SalesAssistantStore | null;
}

const initialState: SalesAssistantSlice = {
  selectedStore: getInitialSelectedStore(),
};

export const salesAssistantSlice = createSlice({
  name: 'salesAssistantSlice',
  initialState,
  reducers: {
    setSelectedStore: (
      state: Draft<SalesAssistantSlice>,
      action: PayloadAction<SalesAssistantStore>
    ): SalesAssistantSlice => ({
      selectedStore: persistSelectedStore(action.payload),
    }),
    resetSelectedStore: (): SalesAssistantSlice => ({
      selectedStore: clearSelectedStore(),
    }),
  },
});
export const { setSelectedStore, resetSelectedStore } = salesAssistantSlice.actions;

export default salesAssistantSlice.reducer;
export const selectSelectedStore = (state: RootState): SalesAssistantStore | null => state.salesAssistant.selectedStore;
